import TestimonialCard from './TestimonialCard'

export { TestimonialCard }
